import { createLayout, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { DashboardBackgroundScripts } from './ui/dashboard/index.tsx';

export const dashboardBackgroundScriptsLayout: Layout = createLayout({
	globalComponents: [DashboardBackgroundScripts],
});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { DashboardBackgroundScripts } from './ui/dashboard/index.tsx';
